import { tabNavigationStyles, BLUE, PURPLE, BORDER } from "../styles/shared/tabNavigationStyles";
import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

function normalizeTabLabelText(label) {
  if (typeof label !== "string") return label;

  const trimmedLabel = label.trim();
  const hasLetters = /[A-Za-z]/.test(trimmedLabel);
  const isAllUppercase =
    hasLetters &&
    trimmedLabel === trimmedLabel.toUpperCase() &&
    trimmedLabel !== trimmedLabel.toLowerCase();

  if (!isAllUppercase) return label;

  return trimmedLabel
    .split(/(\s+)/)
    .map((part) =>
      /\s+/.test(part) || !part
        ? part
        : `${part.charAt(0)}${part.slice(1).toLowerCase()}`
    )
    .join("");
}

export function TabNavigationLabel({
  label,
  count,
  active = false,
  labelSx,
  countSx,
  contentSizedIndicator = false,
  contentSizedIndicatorOffset = -8,
  contentSizedIndicatorHeight = 3 }) {
  const showCount = count !== undefined && count !== null && count !== "";

  return (
    <Box
      sx={tabNavigationStyles.labelWrapper()}
    >
      <Box
        sx={tabNavigationStyles.labelContent({ active, contentSizedIndicator, contentSizedIndicatorOffset, contentSizedIndicatorHeight })}
      >
      <Box
        component="span"
        sx={tabNavigationStyles.labelText({ labelSx })}
      >
        {normalizeTabLabelText(label)}
      </Box>

      {showCount ? (
        <Box
          component="span"
          className="tab-count-badge"
          sx={tabNavigationStyles.countBadge({ active, countSx })}
        >
          {count}
        </Box>
      ) : null}
      </Box>
    </Box>
  );
}

export default function TabNavigationBar({
  value,
  onChange,
  items = [],
  wrapperClassName,
  tabsClassName,
  wrapperSx,
  tabsSx,
  labelSx,
  countSx,
  borderBottom = true,
  dividerColor = BORDER,
  activeColor = PURPLE,
  idleColor = PURPLE,
  indicatorColor = BLUE,
  indicatorHeight = 3,
  indicatorBorderRadius = 0,
  minHeight = 36,
  tabGap = 3,
  variant = "scrollable",
  scrollButtons = false,
  allowScrollButtonsMobile = false,
  contentSizedIndicator = false,
  contentSizedIndicatorOffset = -8,
  contentSizedIndicatorHeight = 3 }) {
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <Box
      className={wrapperClassName}
      sx={tabNavigationStyles.wrapper({ borderBottom, dividerColor, wrapperSx })}
    >
      <Tabs
        className={tabsClassName}
        value={value}
        onChange={(event, nextValue) => {
          onChange?.(nextValue, event);
        }}
        variant={variant}
        scrollButtons={scrollButtons}
        allowScrollButtonsMobile={allowScrollButtonsMobile}
        sx={tabNavigationStyles.tabs({ minHeight, tabGap, contentSizedIndicator, indicatorColor, indicatorHeight, indicatorBorderRadius, idleColor, activeColor, tabsSx })}
      >
        {safeItems.map((item) => (
          <Tab
            key={item.value}
            value={item.value}
            disableRipple
            disabled={Boolean(item.disabled)}
            label={
              <TabNavigationLabel
                active={item.value === value}
                label={item.label}
                count={item.count}
                labelSx={labelSx}
                countSx={countSx}
                contentSizedIndicator={contentSizedIndicator}
                contentSizedIndicatorOffset={contentSizedIndicatorOffset}
                contentSizedIndicatorHeight={contentSizedIndicatorHeight}
              />
            }
          />
        ))}
      </Tabs>
    </Box>
  );
}
